import { useEffect, useRef } from 'react'
import { cmsDataService } from '@/common/services/cms.data.service'
import { navigationService } from '@/common/services/navigation.service'
import { Modal, type ModalHandlers } from '@/features/membership/modals/Modal'

interface OmniaHeaderInterceptDetail {
    url: string
    category: 'food-and-drink'
}

export const HeaderFoodDrinkIntercept = () => {
    const modalRef = useRef<ModalHandlers | null>(null)
    const isMembershipModalFlowEnabled = cmsDataService.get().enableLoginModalFoodAndBeverage || false

    useEffect(() => {
        document.documentElement.dataset.omniaHeaderFoodDrinkIntercept = 'true'

        const handleHeaderIntercept = (event: Event): void => {
            const detail = (event as CustomEvent<OmniaHeaderInterceptDetail>).detail

            if (!detail?.url) {
                return
            }

            void (async () => {
                const shouldNavigate = await modalRef.current?.handleHeaderNavigationIntercept(detail.url)

                if (shouldNavigate) {
                    navigationService.goTo(detail.url)
                }
            })()
        }

        window.addEventListener('omnia:header-navigation-intercept', handleHeaderIntercept)

        return () => {
            window.removeEventListener('omnia:header-navigation-intercept', handleHeaderIntercept)
            delete document.documentElement.dataset.omniaHeaderFoodDrinkIntercept
        }
    }, [])

    return <Modal ref={modalRef} isMembershipModalFlowEnabled={isMembershipModalFlowEnabled} />
}
